export function formatPhoneNumberForShippingAddress(phoneNumber = "") {
    if (!phoneNumber) {
        return "";
    }
    const countryCodePattern = /^(\+?1)?/;
    return phoneNumber.replace(countryCodePattern, "");
}
